import { GetTransportAssignmentIdsQueryParams, GetTransportAssignmentsQueryParams } from '../../transportOrderApi';
import {
    TransportAssignmentIdsQueryBody,
    TransportAssignmentsQueryBody,
} from '../../types/transportAssignment/queryBody.types';
import { mapToApiMeansOfTransportType } from '../meansOfTransportTypeMapper';
import { mapFilterableStatusesToApiStatuses, mapToApiSort } from './outgoingRequestMappers';
import { mapToApiVehicleType } from '../sharedVehicleMappers';

export const mapToTransportAssignmentsQueryBody = (
    queryParameters: GetTransportAssignmentsQueryParams,
): TransportAssignmentsQueryBody => {
    const filter = mapToTransportAssignmentFilterQueryParameters(queryParameters);
    const hasSomeFilter = Object.values(filter).some((value) => value !== undefined);

    return {
        filter: hasSomeFilter ? filter : undefined,
        sort: queryParameters?.sortBy && mapToApiSort(queryParameters.sortBy),
        limit: queryParameters?.limit,
    };
};

export const mapToTransportAssignmentIdsQueryBody = (
    queryParameters: GetTransportAssignmentIdsQueryParams,
): TransportAssignmentIdsQueryBody => mapToTransportAssignmentFilterQueryParameters(queryParameters);

const mapToTransportAssignmentFilterQueryParameters = (
    queryParameters: GetTransportAssignmentsQueryParams | GetTransportAssignmentIdsQueryParams,
): TransportAssignmentIdsQueryBody => ({
    statuses: queryParameters?.statuses && mapFilterableStatusesToApiStatuses(queryParameters.statuses),
    archived: queryParameters?.archived,
    requested_pick_up: mapToRequestedPickUpIntervalFilter(
        queryParameters?.requestedPickUpFrom,
        queryParameters.requestedPickUpTo,
    ),
    loading_location: queryParameters?.loadingLocation,
    unloading_location: queryParameters?.unloadingLocation,
    vehicle_type: queryParameters?.vehicleType && mapToApiVehicleType(queryParameters.vehicleType),
    manufacturer: queryParameters?.manufacturer,
    means_of_transport_type: queryParameters?.meansOfTransportType
        ? mapToApiMeansOfTransportType(queryParameters.meansOfTransportType)
        : undefined,
    vin_search: queryParameters.vins,
    means_of_transport_id: queryParameters.meansOfTransportId,
    bundle_id: queryParameters.bundleId,
    external_order_id: queryParameters.externalOrderId,
});

const mapToRequestedPickUpIntervalFilter = (from: Date | undefined, to: Date | undefined) => {
    if (from === undefined && to === undefined) {
        return undefined;
    }

    return {
        start_at: from?.toISOString(),
        end_at: to?.toISOString(),
    };
};
